import React, { useState, useEffect } from 'react'
import { Form, FormGroup, Label, Button } from 'reactstrap'
import { TextEditor } from '../Common/TextEditor'
import { updateData } from '../../lib/taskm'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

const TaskEdit = ({ value = '', id, setStatus, status, setUpdatedId, isDarkMode = false }) => {
	const [newAnswer, setNewAnswer] = useState(value || '')
	const [saving, setSaving] = useState(false)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	useEffect(() => {
		if (isDarkMode) {
			const style = document.createElement('style')
			style.id = 'task-edit-ckeditor-dark'
			style.textContent = `
				#editor .ck-editor__editable,
				#editor .ck-content,
				#editor .ck-content p,
				#editor .ck-content h1,
				#editor .ck-content h2,
				#editor .ck-content h3,
				#editor .ck-content h4,
				#editor .ck-content h5,
				#editor .ck-content h6,
				#editor .ck-content li,
				#editor .ck-content span,
				#editor .ck-content div,
				#editor .ck-content strong,
				#editor .ck-content em,
				#editor .ck-content ul,
				#editor .ck-content ol {
					color: #fff !important;
				}
				#editor .ck-editor__editable {
					background-color: #2a2d35 !important;
				}
			`
			document.head.appendChild(style)
			return () => {
				const existingStyle = document.getElementById('task-edit-ckeditor-dark')
				if (existingStyle) {
					existingStyle.remove()
				}
			}
		} else {
			const existingStyle = document.getElementById('task-edit-ckeditor-dark')
			if (existingStyle) {
				existingStyle.remove()
			}
		}
	}, [isDarkMode])

	const handleSubmit = async (e) => {
		e.preventDefault()
		setSaving(true)

		try {
			await updateData({
				id: id,
				desc: newAnswer
			})
			setStatus(!status)
			showToastMessage('Task updated successfully!')
			setUpdatedId(id)
		} catch (error) {
			console.error('Error updating task:', error)
		} finally {
			setSaving(false)
		}
	}

	useEffect(() => {
		if (value) setNewAnswer(value)
	}, [value])


	const labelStyle = {
		color: isDarkMode ? '#fff' : 'inherit'
	}

	return (
		<Form onSubmit={handleSubmit}>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<div className="col-12">
				<FormGroup>
					<Label className="form-control-label" style={labelStyle}>Description</Label>
					<div id="editor">
						<TextEditor value={newAnswer} setValue={setNewAnswer} />
					</div>
				</FormGroup>
			</div>

			<div className="d-flex justify-content-between mt-4">
				<Button type="submit" color="primary" disabled={saving}>
					{saving ? 'Updating...' : 'Update'}
				</Button>
			</div>
		</Form>
	)
}

export { TaskEdit }
